import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Breadcrumb } from 'shared';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'ds-breadcrumb',
  imports: [RouterModule, IconComponent],
  templateUrl: './breadcrumb.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './breadcrumb.component.scss',
})
export class BreadcrumbComponent {
  public breadcrumbs = input.required<Breadcrumb[] | null>();

  protected historyState = computed(() => {
    this.breadcrumbs();

    return history.state;
  });
}
